<template>
  <div class="card p-0 mb-2">
    <div class="card-header p-0 border-0" :id="`counterParty${index}`">
      <h2 class="mb-0 d-flex">
        <button
          class="counter-party btn btn-link p-0 text-left collapsed flex-grow-1 line-height-1 d-flex align-items-center border-0 btn-square"
          type="button"
          data-toggle="collapse"
          :data-target="`#collapse${index}`"
          aria-expanded="false"
          :aria-controls="`collapse${index}`"
        >
          <div class="bg-primary text-white flex-grow-0 p-3 mr-2">{{ parseInt(index) + 1}}</div>
          <span class="flex-grow-1">{{ counterParty.name }}</span>
          <i class="fas fa-plus-circle float-right mr-3"></i>
          <i class="fas fa-minus-circle float-right mr-3"></i>
        </button>
      </h2>
    </div>

    <div :id="`collapse${index}`" class="collapse" :aria-labelledby="`counterParty${index}`" data-parent="#counterParties">
      <div class="card-body">
        <InertiaLink v-if="isntClausifyUser" :href="route('counter-party.edit', [counterParty.id])" class="btn btn-primary flex-grow-0 mb-5">
          Edit {{ counterParty.name }}
        </InertiaLink>

        <div v-for="assetType in sortedAllAssetTypes" :key="assetType.id">
          <div v-if="showAsset(assetType)" class="mb-5">
            <h5><Icon :icon="assetType.meta.icon" :width="20" class="mr-2" /> {{ assetType.name }}</h5>

            <div v-if="groupedAssets[assetType.id] && groupedAssets[assetType.id].length > 0" class="row">
              <div class="col">

                <table class="table table-hover table-fixed mb-0">
                  <thead>
                    <tr>
                      <th width="51%" scope="col">Name</th>
                      <th width="15%" scope="col">Status</th>
                      <th width="15%" scope="col" class="text-right">Updated At</th>
                      <th width="19%" scope="col"></th>
                    </tr>
                  </thead>
                  <CounterPartyAsset
                    v-for="asset in groupedAssets[assetType.id]" :key="asset.id"
                    :assetType="assetType"
                    :asset="asset"
                    :organisation="organisation"
                    :counterParty="counterParty"
                  />
                </table>

              </div>
            </div>

            <p v-if="(avaliableAssetIds.includes(assetType.id)) && !groupedAssets[assetType.id]">
              {{ counterParty.name }} doesn't have a {{ assetType.name }}. You can
              <InertiaLink :href="route('asset.create', assetType.slug)">create one here</InertiaLink>.
            </p>
          </div>
        </div>

        <div v-if="showProgrammesOfWork" class="mb-5">
          <h5><Icon icon="Puzzle" :width="20" class="mr-2" /> Programmes Of Work</h5>

          <div v-if="counterParty && counterParty.programmes_of_work_as_counterparty && counterParty.programmes_of_work_as_counterparty.length > 0" class="row">
            <div class="col">

              <table class="table table-hover table-fixed mb-0">
                <thead>
                  <tr>
                    <th width="80%" scope="col">Name</th>
                    <th width="20%" scope="col" class="text-right">Updated At</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="programmeOfWork in counterParty.programmes_of_work_as_counterparty" :key="programmeOfWork.id">
                    <td>{{ programmeOfWork.name }}</td>
                    <td class="text-right text-nowrap">{{ programmeOfWork.updated_at | localDateTime }}</td>
                  </tr>
                </tbody>
              </table>

            </div>
          </div>

          <p v-if="showProgrammesOfWorkEmtpyState">
            {{ counterParty.name }} doesn't have any Programmes Of Work. You can create one when setting up a
            <InertiaLink :href="route('asset.create', 'statement-of-work')">Statement Of Work</InertiaLink>.
          </p>
        </div>

        <h5>Existing Documents</h5>
        <table v-if="counterParty.uploads.length > 0" class="table table-hover table-fixed mb-0">
          <thead>
            <tr>
              <th width="61%" scope="col">Name</th>
              <th width="20%" scope="col" class="text-right">Uploaded At</th>
              <th width="19%" scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="upload in counterParty.uploads" :key="upload.id">
              <td>{{ upload.name }}</td>
              <td class="text-right">{{ upload.updated_at | localDateTime }}</td>
              <td>
                <div class="d-flex">
                  <a class="text-nowrap btn btn-primary btn-sm mr-2 ml-auto" :href="route('upload.show', upload.id)" target="_blank" >View</a>
                  <a class="text-nowrap btn btn-primary btn-sm mr-2" :href="route('upload.download', upload.id)">Download</a>
                  <form @submit.prevent="destroy(upload.id)">
                    <LoadingButton
                      :loading="destroyForm.processing"
                      class="text-nowrap btn btn-danger btn-sm"
                      type="submit"
                    >Delete</LoadingButton>
                  </form>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <button v-if="!showUploadForm" @click="showUploadForm = true" class="btn btn-primary mt-2" type="button">Upload New Document</button>
        <form v-else @submit.prevent="upload" class="card">
          <div class="card-body bg-light">
            <div class="form-group">
              <TextInput
                class="text-primary"
                v-model="form.name"
                :errors="errors ? errors.name : []"
                type="text"
                label="What is the name of this document?"
                autocapitalize="off"
                @input="errors.name = []"
                validateSuccess
                validateError
              />
            </div>
            <div class="form-group">
              <input
                type="file"
                ref="file"
                :class="{
                  success: !errors && errors.document && errors.document.length && value && valid,
                  error: errors && errors.document && errors.document.length && validateError,
                }"
                @input="form.document = $event.target.files[0]"
              />
              <Error v-if="errors && errors.document && errors.document.length" :errors="errors.document" />
            </div>

            <div class="form-group">
              <div class="row">
                <div class="col-md-3">
                  <LoadingButton
                    :loading="form.processing"
                    class="btn btn-primary btn-block"
                    type="submit"
                  >Upload</LoadingButton>
                  <button
                    class="btn btn-secondary btn-block"
                    @click.prevent="showUploadForm = false"
                  >Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </form>

      </div>
    </div>
  </div>
</template>

<script>
import helpers from '@/Mixins/helpers';
import Icon from '@/Icons/Icon';
import LoadingButton from '@/Shared/LoadingButton';
import TextInput from '@/Shared/Inputs/Text';
import FileInput from '@/Shared/Inputs/File';
import Error from '@/Shared/Inputs/Error'
import CounterPartyAsset from './CounterPartyAsset';

const fileDownload = require('js-file-download');

export default {
  mixins: [helpers],

  components: {
    Icon,
    FileInput,
    TextInput,
    LoadingButton,
    CounterPartyAsset,
    Error,
  },

  props: {
    index: Number,
    organisation: Object,
    counterParty: Object,
    allAssetTypes: Array,
    assetTypes: Array,
    errors: Object,
  },

  data() {
    return {
      downloading: false,
      error: false,
      showUploadForm: false,
      form: this.$inertia.form(this.formSetup()),
      sortedAllAssetTypes: this.allAssetTypes.sort((a, b) => a.sort - b.sort),
      destroyForm: this.$inertia.form(),
    }
  },

  computed: {
    avaliableAssetIds() {
      return this.assetTypes.flatMap((assetType) => assetType.id);
    },

    isntClausifyUser() {
      return !!this.counterParty.user_id;
    },

    groupedAssets() {
      const allAssets = [];

      if (this.counterParty.assets) {
        this.counterParty.assets.forEach((asset) => {
          const assetTypeId = asset.asset_type_id;

          if (!allAssets[assetTypeId]) {
            allAssets[assetTypeId] = [];
          }

          allAssets[assetTypeId].push(asset);
        });
      }

      if (this.counterParty.asset_as_counterparty) {
        this.counterParty.asset_as_counterparty.forEach((asset) => {
          const assetTypeId = asset.asset_type_id;

          if (!allAssets[assetTypeId]) {
            allAssets[assetTypeId] = [];
          }

          allAssets[assetTypeId].push(asset);
        });
      }

      return allAssets.map((assetType) => assetType.sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at)));
    },

    programmesOfWork() {
      if (this.counterParty.programmes_of_work_as_counterparty) {
        if (this.counterParty.programmes_of_work) {
          return [...this.counterParty.programmes_of_work, ...this.counterParty.programmes_of_work_as_counterparty];
        }
        return this.counterParty.programmes_of_work_as_counterparty;
      }

      return this.counterParty.programmes_of_work;
    },

    hasMsaSuiteDocuments() {
      // TODO: Create suites in the Database
      const msaSuiteDocumentSlugs = [
        'master-service-agreement',
        'statement-of-work',
        'work-category',
      ];

      const msaDocs = this.assetTypes.filter((assetType) => msaSuiteDocumentSlugs.includes(assetType.slug));
      return msaDocs.length > 0;
    },

    hasFrameworkSuiteDocuments() {
      // TODO: Create suites in the Database
      const frameworkSuiteDocumentSlugs = [
        'framework-agreement',
        'framework-agreement-sow',
      ];

      const frameworkDocs = this.assetTypes.filter((assetType) => frameworkSuiteDocumentSlugs.includes(assetType.slug));
      return frameworkDocs.length > 0;
    },

    showProgrammesOfWork() {
      if (this.hasMsaSuiteDocuments) return true;

      if (this.counterParty && this.counterParty.programmes_of_work_as_counterparty && this.counterParty.programmes_of_work_as_counterparty.length > 0) return true;

      return false;
    },

    showProgrammesOfWorkEmtpyState() {
      return this.hasMsaSuiteDocuments && !(this.counterParty && this.counterParty.programmes_of_work_as_counterparty && this.counterParty.programmes_of_work_as_counterparty.length > 0);
    },
  },

  methods: {
    formSetup() {
      return {
        name: null,
        document: null,
        ownerable_id: this.counterParty.id,
        ownerable_type: this.counterParty.user_id ? 'App\\Models\\CounterParty' : 'App\\Models\\Organisation',
      }
    },

    label(state, isWith, assetOriginatorId) {
      if (isWith === 'originator' && assetOriginatorId === this.organisation.id) return state.organisation;
      return state.counterparty;
    },

    showAsset(assetType) {
      if (!assetType.meta) return false;

      // If you have documents then show the type
      if (this.groupedAssets[assetType.id] && this.groupedAssets[assetType.id].length > 0) return true;

      // You are able to create the document
      if (this.avaliableAssetIds.includes(assetType.id)) return true;

      return false;
    },

    upload() {
      const route = this.route('upload.store');

      this.form.post(route, {
        preserveScroll: true,
        onSuccess: () => {
          this.form = this.$inertia.form(this.formSetup());
          this.$refs.file.value = null;
        },
      });
    },

    destroy(id) {
      const route = this.route('upload.destroy', id);

      this.destroyForm.delete(route, {
        preserveScroll: true,
        onSuccess: () => {
          //
        },
      });
    },

    download(id) {
      this.downloading = true;
      this.error = false;

      window.axios({
        url: this.route('upload.download', id),
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        this.downloading = false;
        fileDownload(response.data, `${this.asset.name}.pdf`);
      }).catch((error) => {
        this.error = true;
        this.downloading = false;
        this.errors = error.response.data.errors;
        throw new Error(error);
      });
    }
  },
};
</script>
